export const en = {
  search: {
    placeholder: "Insert a word to search...",
    results: "Results",
    search: "Search",
  },
};
